import React from 'react';
import { Badge } from '@/components/ui/badge';

import { EmployeePosition } from './types';

export const SearchDropdown: React.FC<
  React.PropsWithChildren<{
    searchPositions: EmployeePosition[];
    selectedPositionId: string;
    onPositionSelect: (positionId: string) => void;
    onClose: () => void;
    t: (key: string, options?: { defaultValue?: string }) => string;
  }>
> = ({ searchPositions, selectedPositionId, onPositionSelect, onClose, t }) => {
  const handlePositionClick = (positionId: string) => {
    onPositionSelect(positionId);
  };

  return (
    <div className="position-absolute w-100 mt-1" style={{ zIndex: 9999 }}>
      <div className="position-search-dropdown">
        {searchPositions.length > 0 ? (
          searchPositions.map((position) => (
            <div
              key={position.Id}
              className={`position-search-dropdown-item p-3 ${
                selectedPositionId === position.Id ? 'selected' : ''
              }`}
              onClick={() => handlePositionClick(position.Id)}>
              <div className="fw-bold small">{position.Name}</div>
              <div className="small text-muted">{position.flair__Title__c}</div>
              <Badge
                variant={position.flair__Staffed__c ? 'secondary' : 'success'}
                className="small">
                {position.flair__Staffed__c
                  ? t('statusStaffed')
                  : t('statusAvailable')}
              </Badge>
            </div>
          ))
        ) : (
          <div className="text-muted small text-center py-3">
            {t('noPositionsFound')}
          </div>
        )}
      </div>
    </div>
  );
};
